import { useLoggedInUser } from "components/LoggedInUserProvider";
import React from "react";
import TrainerHorseDetailsPage from "./Trainer";
import VetHorseDetailsPage from "./Vet";

const HorseDetailsPage = () => {
  const { currentUser } = useLoggedInUser();

  if (currentUser.isTrainer || currentUser.isRacingOfficial) {
    return <TrainerHorseDetailsPage />;
  }
  if (currentUser.isVeterinarian || currentUser.isAdmin) {
    return <VetHorseDetailsPage />;
  }

  return <></>;
};

export default HorseDetailsPage;
